<template>
  <div>
    <div v-if="!isPostVenta">
      <div>
        <v-row>
          <v-col cols="12" style="text-align: end">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="$emit('openCreatePolizaModal')"
                  :disabled="leadIncomplete"
                  class="common-botton mr-4"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  Crear nueva póliza
                </v-btn>
              </template>
              <span>Completa los datos del lead.</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
      <div v-if="polizasCliente.length > 0 && !sPostVenta">
        <div class="pt-5" v-for="(poliza, idx) in polizasCliente" :key="idx">
          <CommonExpansionPanel>
            <template v-slot:title-panel>
              Datos de Póliza #{{ poliza.id }}
            </template>
            <v-expansion-panel-content>
              <div>
                <EmisionDetalleCliente :polizaData="poliza" />
              </div>
            </v-expansion-panel-content>
          </CommonExpansionPanel>
        </div>
      </div>
      <div v-else>
        <v-col
          cols="12"
          md="12"
          style="align-items: center; text-align: center; padding: 5%"
        >
          <span class="titulo-header">Sin resultados que mostrar</span>
        </v-col>
      </div>
    </div>
    <div v-if="isPostVenta">
      <EmisionesIframe :clienteInfo="clienteInfo" />
    </div>
  </div>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import EmisionDetalleCliente from "./EmisionDetalleCliente.vue";
import EmisionesIframe from "./EmisionesIframe.vue";

/**
 * EmisionClienteIndex es el componente principal para mostrar las pólizas de un cliente.
 * Se encarga de renderizar la lista de pólizas o una vista alternativa para roles de post-venta.
 */
export default {
  /**
   * @vuese
   * @group Components
   * Componentes hijos utilizados por EmisionClienteIndex.
   */
  components: {
    // Componente para paneles expandibles.
    CommonExpansionPanel,
    // Componente para mostrar el detalle de una póliza.
    EmisionDetalleCliente,
    // Componente para mostrar una vista de iframe para post-venta.
    EmisionesIframe,
  },
  /**
   * @vuese
   * @group Properties
   * Propiedades que el componente acepta.
   */
  props: {
    /**
     * Array de las pólizas del cliente.
     */
    polizasCliente: Array,
    /**
     * Booleano que indica si se pueden editar los datos.
     */
    canEdit: {
      type: Boolean,
      default: true,
    },
    /**
     * Objeto con la información del cliente.
     */
    clienteInfo: {
      type: Object,
      default: () => {},
    },
    /**
     * Booleano que indica si el lead está incompleto.
     */
    leadIncomplete: {
      type: Boolean,
      default: false,
    },
  },
  /**
   * @vuese
   * @group Data
   * Datos locales del componente.
   */
  data() {
    return {
      /**
       * Rol del usuario actual.
       */
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      /**
       * Variable para cambiar entre componentes (actualmente no utilizada a fondo).
       */
      switch_data: 1,
    };
  },

  /**
   * @vuese
   * @group Methods
   * Métodos del componente.
   */
  methods: {
    /**
     * Cambia el valor de `switch_data` para renderizar un componente diferente.
     * @param {number} component - El identificador del componente a mostrar.
     */
    changeComponent(component) {
      this.switch_data = component;
    },
  },

  /**
   * @vuese
   * @group Computed
   * Propiedades computadas del componente.
   */
  computed: {
    /**
     * Determina si el usuario tiene un rol de post-venta.
     * @returns {boolean} `true` si el rol es 'POSTVENTA' or 'POST-VENTA', de lo contrario `false`.
     */
    isPostVenta() {
      if (
        this.rol.includes("POSTVENTA") ||
        this.rol.includes("POST-VENTA") ||
        this.rol.includes("INBOUND")
      )
        return true;
      else return false;
    },
  },
};
</script>
